// Primary navigation links. `children` renders a dropdown (Services).
export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  {
    label: "Services",
    to: "/services",
    children: [
      { label: "Transportation", to: "/transportation" },
      { label: "Warehousing", to: "/warehouse" },
      { label: "Machinery", to: "/machinery" },
    ],
  },
  { label: "FAQs", to: "/faq" },
  { label: "Contact", to: "/contact" },
  { label: "Careers", to: "/careers" },
];
